import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '../../core/services/account.service';
import { Permission } from '../../core/models/role.model';

/**
 * Blocks a route unless the signed-in member's role grants `permission`. Hiding the nav item isn't
 * enough on its own — a member can still type the URL — so admin screens carry this too. The
 * backend enforces the same permissions; this only keeps the UI honest.
 */
export const permissionGuard = (permission: Permission): CanActivateFn => {
  return () => {
    const account = inject(AccountService);
    const router = inject(Router);
    if (account.can(permission)) return true;
    router.navigate(['/app/dashboard']);
    return false;
  };
};
